import { BaseRepository } from '../../infra/base.repository'
import { ConfigService } from '../../infra/config'
import type { TaxParamEntity } from './tax-param.entity'

export class TaxParamsRepository extends BaseRepository<TaxParamEntity> {
    constructor(
        private config: ConfigService = new ConfigService(),
        token?: string,
        cache?: any,
    ) {
        super(config.posApiUrl + '/tax-params', token, cache)
    }
}
